module.exports = __webpack_public_path__ + "static/media/varie6.305bf55a.jpg";